module.exports = {"id":"206590","name":"Moi Gómez","rating":"74","photo":"./data/images/photos/4/206590.png","club":{"name":"SD Huesca","logo":"./data/images/clubs/SDHuesca.png"},"positions":["MG","MOC","MC","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MoiGomez0.json
// module id = 3070
// module chunks = 0